import { render } from "./WorkshopHomeNewPres.vue?vue&type=template&id=f2a5c628"
import script from "./WorkshopHomeNewPres.vue?vue&type=script&lang=js"
export * from "./WorkshopHomeNewPres.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__